module.exports = __webpack_public_path__ + "static/media/XCV.1b5ae4fc.svg";